import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSessionService } from '../services/user-session/user-session.service';
import { catchError, tap } from 'rxjs/operators';
import { AppNetworkService } from '../services/app-network-service/app-network.service';
import { Router } from '@angular/router';
import { AppRoutes } from '../Constants/app-routes';
import { SessionManager } from '../services/app-session-manager/session-manager.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    private _userSessionService: UserSessionService,
    private _sessionManager: SessionManager,
    private _router: Router,
    private _networkService: AppNetworkService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this._networkService.isConnected()) {
      throw 'No Connection';
    }

    if (this._userSessionService.isSessionActive()) {
      request = request.clone({
        headers: request.headers.set(
          'Authorization',
          'Bearer ' + this._sessionManager.getToken()
        ),
      });
    }

    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              throw err;
            }
            this._userSessionService.endUserSession();
            this._router.navigateByUrl(AppRoutes.login);
          }
        }
      )
    );
  }
}
